module.exports = __webpack_public_path__ + "resources/img/logo_bugs_m.3a4fd0dbb83abc4c37655687ed97b879.png";